import { Injectable } from '@angular/core';
import { SeuIconInterface } from '@seu-types';

@Injectable({
  providedIn: 'root',
})
export class IconsRegistry {
  private readonly registry = new Map<string, string>();

  public registerIcons(icons: SeuIconInterface[]): void {
    icons.forEach((icon: SeuIconInterface) =>
      this.registry.set(icon.name, icon.data)
    );
  }

  public getIcon(iconName: string): string | undefined {
    if (!this.registry.has(iconName)) {
      console.warn(
        `We could not find the dinosaur Icon with the name ${iconName}, did you add it to the Icon registry?`
      );
    }
    return this.registry.get(iconName);
  }
}
